// @ts-check

import {
  STREAM_ACTIVITY_KIND_REASONING,
  STREAM_ACTIVITY_KIND_TOOL,
} from "./streamActivityReducer"

/** Nombres alineados a eventos SSE / fila del timeline (extensible). */
export const STREAM_ACTIVITY_TIMELINE_EVENT = {
  REASONING_START: "reasoning-start",
  REASONING_END: "reasoning-end",
  TOOL: "tool",
  TOOL_AWAITING_APPROVAL: "tool-awaiting-approval",
  READY: "ready",
}

/**
 * Icono PrimeIcons para cada nombre de evento de timeline (sin color propio).
 *
 * @param {string | null | undefined} eventName
 * @returns {string | null} clases `pi …` o null si no hay icono
 */
export function mapStreamTimelineEventToIconClass(eventName) {
  switch (eventName) {
    case STREAM_ACTIVITY_TIMELINE_EVENT.REASONING_START:
      return "pi pi-comments"
    case STREAM_ACTIVITY_TIMELINE_EVENT.REASONING_END:
      return "pi pi-clock"
    case STREAM_ACTIVITY_TIMELINE_EVENT.TOOL:
      return "pi pi-wrench"
    case STREAM_ACTIVITY_TIMELINE_EVENT.TOOL_AWAITING_APPROVAL:
      return "pi pi-clock"
    case STREAM_ACTIVITY_TIMELINE_EVENT.READY:
      return "pi pi-check-circle"
    default:
      return null
  }
}

/**
 * @param {import("./estimationAgent.types").StreamActivitySegment} segment
 * @returns {string | null}
 */
export function streamTimelineEventFromSegment(segment) {
  if (segment.kind === STREAM_ACTIVITY_KIND_REASONING) {
    return segment.status === "active" ?
        STREAM_ACTIVITY_TIMELINE_EVENT.REASONING_START
      : STREAM_ACTIVITY_TIMELINE_EVENT.REASONING_END
  }
  if (segment.kind === STREAM_ACTIVITY_KIND_TOOL) {
    return segment.awaitingUserApproval === true ||
      segment.awaitingAskQuestionsInput === true ?
        STREAM_ACTIVITY_TIMELINE_EVENT.TOOL_AWAITING_APPROVAL
      : STREAM_ACTIVITY_TIMELINE_EVENT.TOOL
  }
  return null
}
